<template>
    <div class="modal-quick-tutorial">
        <vue-modal v-model="modal.isVisible" :header="false" :footer="false" :backdrop="false"
            :modalBodyClass="$prefixClass.modal + '-common-tutorial'">
            <h4>{{ $t('app.components.quick_tutorial')}}</h4>
            <p class="m-b-0">{{ $t('app.components.tutorial_description')}}</p>
            <a-tabs type="card" tab-position="left" :prefixCls="$prefixClass.tabs" class="tutorial-wapper" v-model="modal.type"
                @change="tabChange">
                <a-tab-pane :class="[item.key+'-tutorial']" v-for="item in availableList" :key="item.key" :tab="$t('app.menu.'+item.key)">
                    <div class="quick-content m-b-24">
                        <div>
                            <h5 class="primary-color m-0">{{item.title}}</h5>
                            <p class="description m-0 p-r-10">
                                {{item.description}}<br>
                                <a class="a-link info-color" :href="item.href" target="_blank">{{$t('app.buttons.learn_more')}}</a>
                            </p>
                        </div>
                        <div :class="['quick-content-video']">
                            <iframe loading="lazy" width="auto" height="160px" :src="item.youtubeEmbed" frameborder="0"
                                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                allowfullscreen></iframe>
                        </div>
                    </div>
                </a-tab-pane>
            </a-tabs>
            <a-button type="primary" @click="startTrial">{{ $t('app.buttons.start_trial')}}</a-button>
        </vue-modal>
    </div>
</template>
<script>
    import {tutorials} from '@/modules/dashboard/constant'
    export default {
        name: "ModalQuickTutorial",
        props: {
            value: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                itemSelected: null
            };
        },
        computed: {
            modal: {
                get: function () {
                    return this.value;
                },
                set: function (newValue) {
                    this.$emit("input", newValue);
                },
            },
            availableList: function () {
                return tutorials
            },
        },
        watch: {
        },
        created() {
            this.tabChange(this.modal.type)
        },
        methods: {
            tabChange(value) {
                this.itemSelected = tutorials.find(item => item.key === value)
            },
            startTrial() {
                this.$emit('startTrial')
            }
        }
    };
</script>
<style lang="scss">
    .modal-quick-tutorial {
        .#{$modal} {
            &-common-tutorial {
                text-align: center;
                width: 820px !important;
                .#{$tabs} {
                    margin: auto;
                    margin-top: 24px;
                    &-bar {
                        border: none;
                    }
                    &-tab {
                        font-size: 16px;
                        background: $white-color !important;
                        border: 1px solid $line-color !important;
                        border-radius: 8px !important;
                        font-weight: normal;
                        text-align: left !important;
                        line-height: 50px !important;
                        width: 175px;
                        height: 50px !important;
                        color: $text-color;
                        &:hover {
                            color: $primary-color;
                        }
                    }

                    &-tab-active {
                        border-radius: 8px !important;
                        border: unset !important;
                        background: $primary-color-light !important;
                        color: $white-color !important;
                    }

                    &-card-content {
                        border: none;
                        text-align: left;
                        .quick-content {
                            padding: 16px;
                            border: 1px solid $line-color !important;
                            border-radius: 8px !important;
                            height: 190px;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            div:first-child {
                                max-width: 265px;
                            }
                            .quick-content-video {
                                max-height: 160px;
                            }
                        }
                    }
                }
            }
            &-content {
                min-height: 385px;
                border-radius: 8px;
                width: 100%;
            }
            &-body {
                height: 100%;
                width: 100%;
                padding-top: 32px;
            }
        }
    }
</style>
